export const NETWORKS = {
  opBNB: {
    chainId: '0xCC', // 204 in decimal
    chainName: 'opBNB Mainnet',
    nativeCurrency: { 
      name: 'BNB', 
      symbol: 'BNB', 
      decimals: 18 
    },
    rpcUrls: ['https://opbnb-mainnet-rpc.bnbchain.org'],
    blockExplorerUrls: ['https://opbnbscan.com/'],
    contracts: {
      staking: '0x82e4890b8183Ad42197e210449088E311AA77505', // UPDATE: Replace with new USD-token contract address
      token: '0x947A9c2188b2c855cb780e46eC8aCFD6707A029B' // TRAIL token on opBNB
    }
  },
  opBNBTestnet: {
    chainId: '0x15EB', // 5611 in decimal
    chainName: 'opBNB Testnet',
    nativeCurrency: { 
      name: 'tBNB', 
      symbol: 'tBNB', 
      decimals: 18 
    },
    rpcUrls: ['https://opbnb-testnet-rpc.bnbchain.org'],
    blockExplorerUrls: ['https://testnet.opbnbscan.com/'],
    contracts: {
      staking: '0xa1060e783Ef2c02606d90Fd96E913209625Dc68e', // UPDATE: Replace with new testnet contract address
      token: '0xBf6596a279172D330b8b732D257Ee633B6FDA911' // Replace with testnet TRAIL token
    }
  }
};

export const getNetworkName = (chainId) => {
  switch (chainId) {
    case '0xCC':
    case 204:
      return 'opBNB Mainnet';
    case '0x15EB':
    case 5611:
      return 'opBNB Testnet';
    default:
      return 'Unknown Network';
  }
};

export const isValidNetwork = (chainId) => {
  return chainId === '0xCC' || chainId === '0x15EB' || chainId === 204 || chainId === 5611;
};

// NEW: Get contract addresses for current network
export const getContracts = (chainId) => {
  switch (chainId) {
    case '0xCC':
    case 204:
      return NETWORKS.opBNB.contracts;
    case '0x15EB':
    case 5611:
      return NETWORKS.opBNBTestnet.contracts;
    default:
      return null;
  }
};

// NEW: Get network configuration
export const getNetworkConfig = (chainId) => {
  switch (chainId) {
    case '0xCC':
    case 204:
      return NETWORKS.opBNB;
    case '0x15EB':
    case 5611:
      return NETWORKS.opBNBTestnet;
    default:
      return null;
  }
};

// NEW: Helper to get explorer URL for transaction
export const getExplorerUrl = (chainId, hash, type = 'tx') => {
  const config = getNetworkConfig(chainId);
  if (!config) return '';
  
  const baseUrl = config.blockExplorerUrls[0];
  return `${baseUrl}${type}/${hash}`;
};

// NEW: Helper to get explorer URL for address
export const getAddressExplorerUrl = (chainId, address) => {
  return getExplorerUrl(chainId, address, 'address');
};

// NEW: Check if we're on testnet
export const isTestnet = (chainId) => {
  return chainId === '0x15EB' || chainId === 5611;
};

// NEW: Get network display info
export const getNetworkDisplayInfo = (chainId) => {
  const config = getNetworkConfig(chainId);
  if (!config) return { name: 'Unknown', isTestnet: false, color: '#gray' };
  
  return {
    name: config.chainName,
    isTestnet: isTestnet(chainId),
    color: isTestnet(chainId) ? '#ff6b6b' : '#51cf66'
  };
};